<template>
  <div>
    <b-modal size="xl" centered scrollable id="modal-document" ref="modal-document" :header-bg-variant="headerBgVariant()" @close="cancelForm">
      <template #modal-header>
        <div class="w-100">
          <h5 class="d-inline-block">{{ modalTitle }} <label style="color:#9c3c05">{{ libelle }}</label></h5>
          <button type="button" aria-label="Close" class="close pull-right" @click="$bvModal.hide('modal-document')">×</button>
          <span class="pull-right mr-4"> {{ stateForm }}</span>
        </div>
      </template>
      <b-form>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <label for="libelle"><strong>Libelle</strong></label>
              <b-form-input id="libelle" type="text" :class="{hasError: errors.libelle !== ''}"
                            v-model="libelle"></b-form-input>
              <span class="field-error">{{ errors.libelle }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="code"><strong>Code</strong></label>
              <b-form-input id="code" type="text" :class="{hasError: errors.code !== ''}"
                            v-model="code"></b-form-input>
              <span class="field-error">{{ errors.code }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="version"><strong>Version</strong></label>
              <b-form-input id="version" type="text" :class="{hasError: errors.version !== ''}"
                            v-model="version"></b-form-input>
              <span class="field-error">{{ errors.version }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <label for="date_publication_journal_officiel"><strong>Date de publication JO</strong></label>
              <b-form-input type="date" id="date_publication_journal_officiel" v-model="date_publication_journal_officiel"></b-form-input>
              <span class="field-error">{{ errors.date_publication_journal_officiel }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="date_debut"><strong>Date début de visibilité</strong></label>
              <b-form-input type="date" id="date_debut" v-model="date_debut" :class="{hasError: errors.date_debut !== ''}"></b-form-input>
              <span class="field-error">{{ errors.date_debut }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="date_fin"><strong>Date fin de visibilité</strong></label>
              <b-form-input type="date" id="date_fin" v-model="date_fin" :class="{hasError: errors.date_fin !== ''}"></b-form-input>
              <span class="field-error">{{ errors.date_fin }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <template slot="label"><b>Secteur :</b></template>
              <b-form-radio-group
                id="radio-group-2-3"
                v-model="secteur"
                name="radio-secteur"
                :class="{hasError: errors.secteur !== ''}"
              >
                <b-form-radio value="ess">ESS</b-form-radio>
                <b-form-radio value="interpro">INTERPRO</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.secteur }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <label for="categorieSelect"><strong>Catégorie</strong></label>
              <b-input-group>
                <b-form-select
                  id="categorieSelect"
                  :plain="true"
                  :options="categoryOptions"
                  v-model="selectedCategory"
                  :class="{hasError: errors.selectedCategory !== ''}"
                  class="mr-3">
                  <template #first>
                    <b-form-select-option :value="null" >-- Sélectionnez une catégorie --</b-form-select-option>
                  </template>
                </b-form-select>
                <b-input-group-append class="mt-2">
                  <i title="Nouvelle catégorie" @click="addCategory()" class="fa fa-plus-circle fa-lg text-success" style="cursor:pointer"></i>
                </b-input-group-append>
              </b-input-group>
              <span class="field-error">{{ errors.selectedCategory }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group v-if="showSousCategory">
              <label for="sousCategorieSelect"><strong>Sous-catégorie</strong></label>
              <b-input-group>
                <b-form-select
                  id="sousCategorieSelect"
                  :plain="true"
                  :options="sousCategoriesOptions"
                  v-model="selectedSousCategory"
                  :class="{hasError: errors.selectedSousCategory !== ''}"
                  class="mr-3">
                  <template #first>
                    <b-form-select-option :value="null" >-- Sélectionnez une sous-catégorie --</b-form-select-option>
                  </template>
                </b-form-select>
                <b-input-group-append class="mt-2">
                  <i title="Nouvelle sous-catégorie" @click="addSousCategorie()" class="fa fa-plus-circle fa-lg text-success" style="cursor:pointer"></i>
                </b-input-group-append>
              </b-input-group>
              <span class="field-error">{{ errors.selectedSousCategory }}</span>
            </b-form-group>
            <b-form-group v-else>
              <label for="gammeSelect"><strong>Famille produit</strong></label>
              <b-form-select
                id="gammeSelect"
                :plain="true"
                :options="gammeOptions"
                v-model="selectedGamme"
                :class="{hasError: errors.selectedGamme !== ''}"
                class="mr-3">
                <template #first>
                  <!-- <b-form-select-option :value="null" >Général</b-form-select-option> -->
                </template>
              </b-form-select>
              <span class="field-error">{{ errors.selectedGamme }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group v-if="showCodeProduit">
              <label for="codeProduitSelect"><strong>Code produit</strong></label>
              <b-input-group>
                <b-form-select
                  id="codeProduitSelect"
                  :plain="true"
                  :options="codeProduitOptions"
                  v-model="selectedCodeProduit"
                  :class="{hasError: errors.selectedCodeProduit !== ''}"
                  class="mr-3">
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Sélectionnez un code produit --</b-form-select-option>
                  </template>
                </b-form-select>
                <span class="field-error">{{ errors.selectedCodeProduit }}</span>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="8">
            <b-row>
              <b-col sm="6">
                <b-form-group>
                  <label for="typeSelect"><strong>Type</strong></label>
                  <b-input-group>
                    <b-form-select
                      id="typeSelect"
                      :plain="true"
                      :options="typeOptions"
                      v-model="selectedType"
                      :class="{hasError: errors.selectedType !== ''}"
                      class="mr-3">
                      <template #first>
                        <b-form-select-option :value="null" >-- Sélectionnez un type --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-input-group-append class="mt-2">
                      <i title="Nouveau type" @click="addType()" class="fa fa-plus-circle fa-lg text-success" style="cursor:pointer"></i>
                    </b-input-group-append>
                  </b-input-group>
                  <span class="field-error">{{ errors.selectedType }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="garantieSelect"><strong>Garantie</strong></label>
                  <multiselect v-model="selectedGaranties"
                    selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
                    deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
                    tag-placeholder="Choisissez une ou plusieurs garantie(s)" placeholder="Choisissez une ou plusieurs garantie(s)"
                    label="text" track-by="value"
                    :options="garantieOptions" :multiple="true"
                    :taggable="true">
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group style="margin-top:20px">
                  <label for="rubriqueSelect"><strong>Rubrique</strong></label>
                  <b-input-group>
                    <b-form-select
                      id="rubriqueSelect"
                      :plain="true"
                      :options="rubriqueOptions"
                      v-model="selectedRubrique"
                      :class="{hasError: errors.selectedRubrique !== ''}"
                      class="mr-3">
                      <template #first>
                        <b-form-select-option :value="null" >-- Sélectionnez une rubrique --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-input-group-append class="mt-2">
                      <i title="Nouvelle rubrique" @click="addRubrique()" class="fa fa-plus-circle fa-lg text-success" style="cursor:pointer"></i>
                    </b-input-group-append>
                  </b-input-group>
                  <span class="field-error">{{ errors.selectedRubrique }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group style="margin-top:20px">
                  <label for="sousRubriqueSelect"><strong>Sous-rubrique</strong></label>
                  <b-input-group>
                    <b-form-select
                      id="sousRubriqueSelect"
                      :plain="true"
                      :options="sousRubriqueOptions"
                      v-model="selectedSousRubrique"
                      :class="{hasError: errors.selectedSousRubrique !== ''}"
                      class="mr-3">
                      <template #first>
                        <b-form-select-option :value="null" >-- Sélectionnez une sous-rubrique --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-input-group-append class="mt-2">
                      <i title="Nouvelle sous-rubrique" @click="addSousRubrique()" class="fa fa-plus-circle fa-lg text-success" style="cursor:pointer"></i>
                    </b-input-group-append>
                  </b-input-group>
                  <span class="field-error">{{ errors.selectedSousRubrique }}</span>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="description"><strong>Description</strong></label>
              <b-form-textarea
                rows="5" no-resize
                id="description" :class="{hasError: errors.description !== ''}"
                v-model="description"></b-form-textarea>
              <span class="field-error">{{ errors.description }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <label for="segmentSelect"><strong>Segment</strong></label>
              <b-form-select
                id="segmentSelect"
                :plain="true"
                :options="segmentOptions"
                v-model="selectedSegment">
                <template #first>
                  <b-form-select-option :value="null" >-- Sélectionnez un segment --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="ordre"><strong>Ordre</strong></label>
              <b-form-input id='ordre' type='number' min="0" v-model="ordre"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="isVisibleClient"><strong>Visible par le client</strong></label>
              <b-form-checkbox id="isVisibleClient" v-model="is_visible_client"></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="oag"><strong>OAG</strong></label>
              <multiselect v-model="selectedOags"
                          selectLabel='Appuyer sur entrer pour sélectionner'
                          selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner'
                          :close-on-select="false"
                          tag-placeholder="Choisissez un ou plusieurs OAG" placeholder="Choisissez un ou plusieurs OAG"
                          label="name" track-by="id" id="oag"
                          :options="oagOptions" :multiple="true"
                          :taggable="true">
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="oap"><strong>OAP</strong></label>
              <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                          selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner'
                          :close-on-select="false" v-model="selectedOaps"
                          tag-placeholder="Choisissez un ou plusieurs OAP" placeholder="Choisissez un ou plusieurs OAP"
                          label="name" track-by="id" id="oap"
                          :options="oapOptions" :multiple="true"
                          :taggable="true">
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <strong><hr style="border:1px solid #1e8eb5"></strong>
        <b-row>
          <b-col sm="4">
            <b-form-group v-if="!isEmpty(selectedDocument)">
              <b-row class="mb-1" v-if="!isEmpty(nom_fichier)">
                <b-col sm="4">
                  <label for="nom_fichier"><b>Fichier : </b></label>
                </b-col>
                <b-col sm="8">
                  <span v-if="isEmpty(nom_fichier)">Aucun fichier</span>
                  <span v-else style="font-size:12px;color:#831491;cursor:pointer"><a href="#" @click="downloadFichier(selectedDocument)"><i class="fa fa-tag"></i>{{ getFileName(nom_fichier, extension) }}</a></span>
                </b-col>
              </b-row>
              <b-row class="mb-1" v-if="!isEmpty(url)">
                <b-col sm="4">
                  <label for="nom_video"><b>Vidéo : </b></label>
                </b-col>
                <b-col sm="8">
                  <span v-if="isEmpty(url)">Aucun vidéo</span>
                  <document-video v-else :url="url"></document-video>
                  <!-- <div v-else>
                    <iframe :src=iframeUrl style="width:650px;height:300px" frameborder="0" allowfullscreen></iframe>
                  </div> -->
                  <!-- <span v-else style="font-size:12px;color:#831491;cursor:pointer"><a href="#" @click=""><i class="fa fa-tag"></i>{{ url }}</a></span> -->
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group>
              <label for="nom_fichier"><strong v-if="(isEmpty(nom_fichier) && isEmpty(url))">Ajouter un fichier ou un vidéo</strong><strong v-else>Remplacer</strong></label>
              <b-form-group>
                <template slot="label"><b>Type de document :</b></template>
                <b-form-radio-group
                  id="radio-group-2-3"
                  v-model="type"
                  name="radio-type"
                >
                  <b-form-radio value="fichier">Fichier</b-form-radio>
                  <b-form-radio value="video">Vidéo</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-file v-if="showFichier" placeholder="Veuillez choisir ou déposer le fichier ici"
                class="file-input"
                drop-placeholder="Déposer le fichier ici..."
                browse-text="Parcourir"
                :state="errors.attachment !== '' ? false : null"
                @change="addFile($event)"
                @input="clearErrors()">
              </b-form-file>
              <span v-if="showFichier" class="field-error">{{ errors.attachment }}</span>

              <b-form-input v-if="showVideo" placeholder="Editer le lien (vidéo uniquement)" v-model="url"></b-form-input>
              <span class="field-error">{{ errors.url }}</span>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100">
          <b-button type="button" @click="cancelForm" size="md" variant="secondary">
            <i class="fa fa-arrow-left"></i> Annuler
          </b-button>
          <b-button type="button" @click="submitForm('publié')" size="md" class="pull-right" variant="primary">
            <i class="fa fa-save"></i> Enregistrer / Publier
          </b-button>
          <b-button type="button" @click="submitForm('brouillon')" size="md" class="pull-right mr-2" variant="warning">
            <i class="fa fa-save"></i> Brouillon
          </b-button>
          <b-button v-if="selectedDocument && selectedDocument.status.libelle_technique === 'document_brouillon'" type="button" @click="deleteDocument()" size="md" class="pull-right mr-2" variant="danger">
            <i class="fa fa-trash"></i> Supprimer
          </b-button>
        </div>
      </template>
    </b-modal>

    <modal-categorie></modal-categorie>
    <modal-sous-categorie :categoryOptions="categoryOptions"></modal-sous-categorie>
    <modal-type :categoryOptions="categoryOptions"></modal-type>
    <modal-rubrique :categoryOptions="categoryOptions"></modal-rubrique>
    <modal-sous-rubrique></modal-sous-rubrique>
  </div>
</template>

<script>
  import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '@/utils/auth'
  import { isEmpty } from "@/utils/fileHelper"
  import ModalCategorie from "../parametrage/ModalCategorie"
  import ModalSousCategorie from "../parametrage/ModalSousCategorie"
  import ModalRubrique from "../parametrage/ModalRubrique"
  import ModalSousRubrique from "../parametrage/ModalSousRubrique"
  import ModalType from "../parametrage/ModalType"
  import Multiselect from 'vue-multiselect'
  import DocumentVideo from "@/components/Bibliotheque/Document/DocumentVideo"

  export default {
    name: 'ModalDocument',
    components: {
      ModalCategorie,
      ModalSousCategorie,
      ModalRubrique,
      ModalSousRubrique,
      ModalType,
      Multiselect,
      DocumentVideo
    },
    props: {
      selectedDocument: {
        document: Object
      }
    },
    data() {
      return {
        libelle: '',
        code: '',
        version: '',
        status_id: '',
        date_debut: new Date().toISOString().slice(0,10),
        date_fin: '',
        description: '',
        garantie: '',
        selectedGaranties: [],
        garantieOptions: [
          {value: 'ij', text: 'IJ'},
          {value: 'inval', text: 'Inval'},
          {value: 'dc', text: 'Décès'}
        ],
        selectedOaps: [],
        oapOptions: [],
        selectedOags: [],
        oagOptions: [],
        nom_fichier: '',
        extension: '',
        is_visible_client: false,
        date_publication_journal_officiel: '',
        attachment: '',
        selectedCategory: null,
        categoryOptions: [],
        selectedSousCategory: null,
        sousCategoriesOptions: [],
        showSousCategory: false,
        showCodeProduit: false,
        selectedType: null,
        typeOptions: [],
        selectedRubrique: null,
        rubriqueOptions: [],
        selectedSousRubrique: null,
        sousRubriqueOptions: [],
        gammeOptions: [],
        codesProduit: [],
        codeProduitOptions: [],
        selectedGamme: null,
        selectedCodeProduit: null,
        selectedGarantie: null,
        segmentOptions: [],
        selectedSegment: null,
        allCategories: [],
        allSousCategories: [],
        allTypes: [],
        allRubriques: [],
        allSousRubriques: [],
        errors: {
          libelle: '',
          code: '',
          version: '',
          status_id: '',
          date_debut: '',
          date_fin: '',
          description: '',
          garantie: '',
          nom_fichier: '',
          is_visible_client: false,
          date_publication_journal_officiel: '',
          attachment: '',
          selectedCategory: '',
          selectedSousCategory: '',
          selectedType: '',
          selectedRubrique: '',
          selectedSousRubrique: '',
          selectedGarantie: '',
          selectedSegment: '',
          selectedGamme: '',
          selectedCodeProduit: '',
          secteur: ''
        },
        modalTitle: 'Création d\'un nouveau document',
        isEmpty,
        mutableSelectedDocument: this.selectedDocument,
        newTypeCreated: false,
        newSousCategorieCreated: false,
        stateForm: '',
        alertDateFin: false,
        secteur: '',
        type: '',
        showFichier: false,
        showVideo: false,
        url: '',
        allGammesProduit: [],
        ordre: 0
        // iframeUrl: ''
      };
    },
    watch: {
      selectedDocument(document) {
        if (!isEmpty(document)) {
          this.modalTitle = 'Modification du document : '
          this.libelle = this.selectedDocument.libelle
          this.status_id = !isEmpty(this.selectedDocument.status) ? this.selectedDocument.status.libelle_bo : ''
          this.code = this.selectedDocument.code
          this.version = this.selectedDocument.version
          this.date_debut = this.selectedDocument.date_debut
          this.date_fin = this.selectedDocument.date_fin
          this.description = this.selectedDocument.description
          if (!isEmpty(this.selectedDocument.garanties)) {
            this.selectedGaranties = []
            for (let dataGarantie of this.selectedDocument.garanties) {
              if (!isEmpty(dataGarantie.garantie)) {
                this.selectedGaranties.push({text: dataGarantie.garantie, value: dataGarantie.garantie});
              }
            }
          } else {
            this.selectedGaranties = []
          }
          if (!isEmpty(this.selectedDocument.oaps)) {
            this.selectedOaps = []
            for (let dataOap of this.selectedDocument.oaps) {
              if (!isEmpty(dataOap.id)) {
                let structure = !isEmpty(dataOap.pivot.structure) ? '(' + dataOap.pivot.structure + ')' : ''
                this.selectedOaps.push({id: dataOap.id, name: dataOap.code + ' ' + structure});
              }
            }
          } else {
            this.selectedOaps = []
          }
          if (!isEmpty(this.selectedDocument.oags)) {
            this.selectedOags = []
            for (let dataOag of this.selectedDocument.oags) {
              if (!isEmpty(dataOag.id)) {
                let structure = !isEmpty(dataOag.pivot.structure) ? '(' + dataOag.pivot.structure + ')' : ''
                this.selectedOags.push({id: dataOag.id, name: dataOag.code + ' ' + structure});
              } 
            }
          }else {
            this.selectedOags = []
          }
          this.is_visible_client = this.selectedDocument.is_visible_client
          this.date_publication_journal_officiel = this.selectedDocument.date_publication_journal_officiel
          this.nom_fichier = this.selectedDocument.nom_fichier
          this.extension = this.selectedDocument.extension
          this.selectedCategory = this.selectedDocument.categorie_id
          this.selectedSousCategory = this.selectedDocument.sous_categorie_id
          this.selectedType = this.selectedDocument.type_id
          this.selectedRubrique = this.selectedDocument.rubrique_id
          this.selectedSousRubrique = this.selectedDocument.sous_rubrique_id
          this.selectedSegment = this.selectedDocument.segment_id
          this.selectedGamme = this.selectedDocument.gamme_produit_id
          this.selectedCodeProduit = this.selectedDocument.produit_id
          this.secteur = this.selectedDocument.secteur
          this.url = !isEmpty(this.selectedDocument.url) ? this.selectedDocument.url : null
          this.ordre = this.selectedDocument.ordre
        } else {
          this.modalTitle = 'Création d\'un nouveau document'
        }
      },
      selectedCategory: function(newValue, oldValue) {
        if (this.selectedCategory) {
          if ((newValue !== null && oldValue !== null && newValue !== oldValue && this.newTypeCreated == false && this.newSousCategorieCreated == false) || isEmpty(this.selectedType) || (this.selectedCategory === 2 && isEmpty(this.selectedSousCategory))) {
            this.selectedType = null
            // this.selectedSousCategory = null
          }
          if (this.selectedCategory === 2) {
            this.showSousCategory = true
            this.showCodeProduit = false
            this.getSousCategories()
          } else {
            this.showSousCategory = false
            this.showCodeProduit = true
          }
          this.getTypes()
          this.getRubriques()
        }
      },
      selectedType: function() {
        this.newTypeCreated = false
      },
      selectedSousCategory: function() {
        this.newSousCategorieCreated = false
      },
      date_fin: function() {
        let today = new Date().getTime()
        let dateFin = new Date(this.date_fin).getTime()
        if (!isEmpty(dateFin) && dateFin < today) {
          this.alertDateFin = true
        }
      },
      selectedGamme() {
        this.codeProduitOptions = []
        if (this.selectedGamme) {
          this.getCodesProduit()
        }
      },
      type() {
        if (this.type === 'fichier') {
          this.showFichier = true
          this.showVideo = false
        } else {
          this.showVideo = true
          this.showFichier = false
        }
      },
      secteur() {
        this.generateGammeOptions();
      },
    },
    async mounted() {
      await this.getDataInputSearch()
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken()
      this.$axios.defaults.headers.common["Accept"] = "application/json"
      this.$axios.defaults.headers.common["Provider"] = getProvider()
      this.getCategories()
      // this.getRubriques()
      this.getSousRubriques()
      this.getSegments()
      this.getGammesProduit()

      this.$event.on('refresh-after-new-categorie', (categorie) => {
        this.categoryOptions.push({text: categorie.libelle, value: categorie.id});
        this.selectedCategory = categorie.id;
      });
      this.$event.on('refresh-after-new-sous-categorie', (sousCategorie) => {
        this.newSousCategorieCreated = true
        this.sousCategorieOptions.push({text: sousCategorie.libelle, value: type.id});
        this.selectedCategory = sousCategorie.categorie_id;
        this.selectedSousCategory = sousCategorie.id;
      });
      this.$event.on('refresh-after-new-type', (type) => {
        this.newTypeCreated = true
        this.typeOptions.push({text: type.libelle, value: type.id});
        this.selectedCategory = type.categorie_id;
        this.selectedType = type.id;
      });
      this.$event.on('refresh-after-new-rubrique', (rubrique) => {
        this.rubriqueOptions.push({text: rubrique.libelle, value: rubrique.id});
        this.selectedRubrique = rubrique.id;
      });
      this.$event.on('refresh-after-new-sousRubrique', (sousRubrique) => {
        this.sousRubriqueOptions.push({text: sousRubrique.libelle, value: sousRubrique.id});
        this.selectedSousRubrique = sousRubrique.id;
      });
      this.$event.on('open-add-document', () => {
        this.mutableSelectedDocument = null
        this.clearForm()
      })
    },
    methods: {
      async getDataInputSearch() {
        let self = this;
        // this.$store.commit("IS_LOADING", true)
        await this.$axios
        .get("/espaceBibliotheque/document/getDataInputSearch")
        .then(response => {
          let user = getUser();
          let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
          for (let oap of response.data.oaps) {
            if (userOaps.indexOf(oap.code) > -1) {
              this.oapOptions.push({id: oap.id, name: oap.code + ' (' + oap.structure.libelle + ')'});
            }
          }
          let userOags = user.profil_active[0].oags.map(oag => oag.code);
          for (let oag of response.data.oags) {
            if (userOags.indexOf(oag.code) > -1) {
              this.oagOptions.push({id: oag.id, name: oag.code + ' (' + oag.structure.libelle + ')'});
            }
          }
        })
        .catch(function(error) {
          console.log(error)
          let text = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.';
          self.$store.commit('IS_LOADING', false)
          self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:text, showConfirmButton: false, timer: 6000})
        });
      },
      headerBgVariant() {
        if (this.selectedDocument && !isEmpty(this.selectedDocument.status)) {
          if (this.selectedDocument.status.libelle_technique == 'document_brouillon') {
            this.stateForm = 'Brouillon'
            return 'warning'
          } else if (this.selectedDocument.status.libelle_technique == 'document_publie') {
            this.stateForm = 'Publié'
            return 'primary'
          } else {
            this.stateForm = 'Archivé'
            return 'secondary'
          }
        } else {
          this.stateForm = ''
          return
        }
      },
      addFile(event) {
        this.attachment = event.target.files[0]
      },
      cancelForm() {
        this.$bvModal.hide('modal-document')
        this.clearErrors()
      },
      submitForm(state) {
        if (this.validateData(state)) {
          let today = new Date().getTime()
          let dateFin = new Date(this.date_fin).getTime()
          let formData = new FormData();
          formData.append('documentId', !isEmpty(this.selectedDocument) ? this.selectedDocument.id : '')
          formData.append('file', this.attachment)
          formData.append('libelle', this.libelle)
          formData.append('code', this.code)
          formData.append('version', this.version)
          formData.append('date_debut', this.date_debut)
          formData.append('date_fin', this.date_fin)
          formData.append('description', this.description)
          formData.append('selectedGaranties', !isEmpty(this.selectedGaranties) ? this.selectedGaranties.map((garantie) => garantie.value) : '')
          formData.append('selectedOags', !isEmpty(this.selectedOags) ? this.selectedOags.map((oag) => oag.id) : '')
          formData.append('selectedOaps', !isEmpty(this.selectedOaps) ? this.selectedOaps.map((oap) => oap.id) : '')
          formData.append('is_visible_client', this.is_visible_client)
          formData.append('categorie_id', this.selectedCategory)
          formData.append('sous_categorie_id', this.selectedSousCategory)
          formData.append('type_id', this.selectedType)
          formData.append('rubrique_id', this.selectedRubrique)
          formData.append('sous_rubrique_id', this.selectedSousRubrique)
          formData.append('segment_id', this.selectedSegment)
          formData.append('gamme_produit_id', this.selectedGamme)
          formData.append('produit_id', this.selectedCodeProduit)
          formData.append('date_publication_journal_officiel', this.date_publication_journal_officiel)
          formData.append('secteur', this.secteur)
          this.url = !isEmpty(this.url) ? this.url : null
          formData.append('url', this.url)
          formData.append('ordre', this.ordre)
          if (isEmpty(this.date_debut) && state == 'publié') {
            this.$swal.fire({
              title: 'Êtes-vous sûr?',
              text: "La date de début de visibilité n'est pas renseigné, le document créé ne sera pas publié.",
              type: 'warning',
              showCancelButton: true,
              cancelButtonColor: "#3085d6",
              confirmButtonColor: "#ff1744",
              confirmButtonText: 'Confirmer',
              cancelButtonText: 'Annuler',
            }).then((result) => {
              if (!isEmpty(result.value) && result.value) {
                this.$store.commit('IS_LOADING', true)
                let self = this;
                formData.append('state', 'brouillon');
                this.$axios
                  .post("/espaceBibliotheque/document/store", formData, {headers: {'Content-Type': 'multipart/form-data'}})
                  .then(response => {
                    this.$store.commit('IS_LOADING', false)
                    this.$refs['modal-document'].hide()
                    this.clearForm()
                    this.$event.emit('refresh-document')
                    this.$event.emit('refresh-document-par-famille')
                    this.$event.emit('refresh-document-epargne-retraite')
                    let title = !isEmpty(this.selectedDocument) ? 'Modification avec succès' : 'Création avec succès'
                    let texte = !isEmpty(this.selectedDocument) ? 'Le document a bien été modifié' : 'Le nouveau document a bien été créé'
                    this.$swal({
                      position: 'top',
                      type: 'success',
                      title: title,
                      text: texte,
                      showConfirmButton: false,
                      timer: 5000
                    })
                  })
                  .catch(function(error) {
                    let text = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.';
                    self.$store.commit('IS_LOADING', false)
                    self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:text, showConfirmButton: false, timer: 6000})
                  });
              }
            })
          } else if (!isEmpty(this.date_fin) && dateFin < today) {
            this.$swal.fire({
              title: 'Êtes-vous sûr?',
              text: "La date de fin de visibilité est antérieure à la date du jour, le document créé sera enregistré au statut 'Archivé'.",
              type: 'warning',
              showCancelButton: true,
              cancelButtonColor: "#3085d6",
              confirmButtonColor: "#ff1744",
              confirmButtonText: 'Confirmer',
              cancelButtonText: 'Annuler',
            }).then((result) => {
              if (!isEmpty(result.value) && result.value) {
                this.$store.commit('IS_LOADING', true)
                let self = this;
                formData.append('state', state);
                this.$axios
                  .post("/espaceBibliotheque/document/store", formData, {headers: {'Content-Type': 'multipart/form-data'}})
                  .then(response => {
                    this.$store.commit('IS_LOADING', false)
                    this.$refs['modal-document'].hide()
                    this.clearForm()
                    this.$event.emit('refresh-document')
                    this.$event.emit('refresh-document-par-famille')
                    this.$event.emit('refresh-document-epargne-retraite')
                    let title = !isEmpty(this.selectedDocument) ? 'Modification avec succès' : 'Création avec succès'
                    let texte = !isEmpty(this.selectedDocument) ? 'Le document a bien été modifié' : 'Le nouveau document a bien été créé'
                    this.$swal({
                      position: 'top',
                      type: 'success',
                      title: title,
                      text: texte,
                      showConfirmButton: false,
                      timer: 5000
                    })
                  })
                  .catch(function(error) {
                    let text = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.';
                    self.$store.commit('IS_LOADING', false)
                    self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:text, showConfirmButton: false, timer: 6000})
                  });
              }
            })
          } else {
            this.$store.commit('IS_LOADING', true)
            let self = this;
            formData.append('state', state);
            this.$axios
              .post("/espaceBibliotheque/document/store", formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.$refs['modal-document'].hide()
                this.clearForm()
                this.$event.emit('refresh-document')
                this.$event.emit('refresh-document-par-famille')
                this.$event.emit('refresh-document-epargne-retraite')
                let title = !isEmpty(this.selectedDocument) ? 'Modification avec succès' : 'Création avec succès'
                let texte = !isEmpty(this.selectedDocument) ? 'Le document a bien été modifié' : 'Le nouveau document a bien été créé'
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: title,
                  text: texte,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
              .catch(function(error) {
                let text = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.';
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:text, showConfirmButton: false, timer: 6000})
              });
          }
        } else {
          this.$swal({
            position: 'top',
            type: 'warning',
            title: 'Attention',
            text: 'Des données obligatoires ne sont pas renseignées',
            showConfirmButton: false,
            timer: 5000
          })
        }
      },
      validateData(state) {
        this.clearErrors();
        let valid = true
        if (state === 'publié') {
          let dateFrom = new Date(this.date_debut)
          let dateTo = new Date(this.date_fin)

          if (this.libelle === "") {
            this.errors.libelle = "Le libellé est obligatoire"
            valid = false
          }
          if (this.date_fin !== null && this.date_fin !== "") {
            if (dateTo.getTime() < dateFrom.getTime()) {
              this.errors.date_fin = "La date de fin doit être postérieure à la date de début"
              valid= false
            }
          }
          if (this.selectedCategory === null) {
            this.errors.selectedCategory = "La catégorie est obligatoire"
            valid = false
          } else {
            if (this.selectedCategory === 2) {
              if (this.selectedSousCategory === null) {
                this.errors.selectedSousCategory = "La sous-catégorie est obligatoire"
                valid = false
              }
            }
          }
          if (this.selectedRubrique === null) {
            this.errors.selectedRubrique = "La rubrique est obligatoire"
            valid = false
          }
          //return valid;
        } else {
          if (this.libelle === "") {
            this.errors.libelle = "Le libellé est obligatoire"
            valid = false
          }
          //return valid;
        }
        if (this.secteur === '') {
          this.errors.secteur = "Le secteur est obligatoire"
          valid = false
        }
        return valid;
      },
      getCategories() {
        return new Promise((resolve, reject) => {
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/categories')
          .then(response => {
            this.allCategories = response.data.categories;
            for (let row of response.data.categories) {
              this.categoryOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
        })
      },
      getSousCategories() {
        return new Promise((resolve, reject) => {
          this.sousCategoriesOptions = [];
          // get sous-categorie where categorie_id = this.selectedCategory
          let self = this;
          this.$axios
            .get('/espaceBibliotheque/sous-categories/' + this.selectedCategory)
            .then(response => {
              this.allSousCategories = response.data.sousCategories;
              for (let row of response.data.sousCategories) {
                this.sousCategoriesOptions.push({text: row.libelle, value: row.id});
              }
              resolve();
            })
            .catch(function(error) {
              resolve();
              self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: 'Une erreur est survenue pendant la récupération des sous-catégories de document. Si le problème persiste contactez le support DOSI.',
                  showConfirmButton: false,
                  timer: 5000
                });
            });
        });
      },
      getTypes() {
        return new Promise((resolve, reject) => {
          this.typeOptions = [];
          // get type where categorie_id = this.selectedCategory
          let self = this;
          this.$axios
            .get('/espaceBibliotheque/types/' + this.selectedCategory)
            .then(response => {
              this.allTypes = response.data.types;
              for (let row of response.data.types) {
                this.typeOptions.push({text: row.libelle, value: row.id});
              }
              resolve();
            })
            .catch(function(error) {
              resolve();
              self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: 'Une erreur est survenue pendant la récupération des types de document. Si le problème persiste contactez le support DOSI.',
                  showConfirmButton: false,
                  timer: 5000
                });
            });
        });
      },
      getRubriques() {
        return new Promise((resolve, reject) => {
          this.rubriqueOptions = [];
          // get rubrique where categorie_id = this.selectedCategory
          let self = this;
          this.$axios
            .get('/espaceBibliotheque/rubriques/' + this.selectedCategory)
            .then(response => {
              this.allRubrique = response.data.rubriques;
              for (let row of response.data.rubriques) {
                this.rubriqueOptions.push({text: row.libelle, value: row.id});
              }
              resolve();
            })
            .catch(function(error) {
              resolve();
              self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: 'Une erreur est survenue pendant la récupération des rubriques de document. Si le problème persiste contactez le support DOSI.',
                  showConfirmButton: false,
                  timer: 5000
                });
            });
        });
      },
      getSousRubriques() {
        return new Promise((resolve, reject) => {
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/sous-rubriques')
          .then(response => {
            this.allSousRubriques = response.data.sousRubrique;
            for (let row of response.data.sousRubriques) {
              this.sousRubriqueOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des sous-rubriques de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
        })
      },
      getSegments() {
        return new Promise((resolve, reject) => {
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/segments')
          .then(response => {
            for (let row of response.data.segments) {
              this.segmentOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des segments de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
        })
      },
      getGammesProduit() {
        return new Promise((resolve, reject) => {
        this.codeProduitOptions = []
        let self = this;
        this.$axios
          .get('/espaceGestion/produit/gestion-gamme')
          .then(response => {
            this.allGammesProduit = response.data.gammesProduit;
            this.gammeOptions.push({text: 'Général', value: null});
            for (let row of response.data.gammesProduit) {
              this.gammeOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des gammes produit. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
        })
      },
      getCodesProduit() {
        return new Promise((resolve, reject) => {
        this.codeProduitOptions = []
        let self = this;
        this.$axios
          .get('/espaceGestion/produit/codes-produit/gamme/' + this.selectedGamme)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            let famillesProduit = response.data.familleProduit
            for (let famille of famillesProduit) {
              for (let produit of famille.produits) {
                this.codeProduitOptions.push({ text: produit.code_produit, value: produit.id });
              }
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un problème est survenu, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000,
            });
          });
        })
      },
      deleteDocument() {
        let self = this;
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: "Voulez-vous vraiment supprimer ce document ?",
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: "#3085d6",
          confirmButtonColor: "#ff1744",
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
        }).then((result) => {
          if (result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .delete("/espaceBibliotheque/document/delete/"+this.selectedDocument.id)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$event.emit('refresh-document')
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le document a bien été supprimé',showConfirmButton: false, timer: 5000})
              this.$refs['modal-document'].hide()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue pendant la suppression du document, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            })
          }
        })
      },
      addCategory() {
        this.$bvModal.show('modal-categorie')
      },
      addSousCategorie() {
        this.newSousCategorieCreated = false
        this.$bvModal.show('modal-sous-categorie')
      },
      addType() {
        this.newTypeCreated = false
        this.$bvModal.show('modal-type')
      },
      addRubrique() {
        this.$bvModal.show('modal-rubrique')
      },
      addSousRubrique() {
        this.$bvModal.show('modal-sous-rubrique')
      },
      getFileName(nom_fichier, extension) {
        return nom_fichier ? nom_fichier +'.'+ extension : 'Aucun fichier'
      },
      downloadFichier(document) {
        this.$eventBus.$emit('callDownloadFichier', document)
      },
      clearForm() {
        this.libelle = ''
        this.code = ''
        this.version = ''
        this.date_debut = ''
        this.date_fin = ''
        this.description = ''
        this.garantie = ''
        this.nom_fichier = ''
        this.is_visible_client = false
        this.date_publication_journal_officiel = ''
        this.selectedCategory = null
        this.selectedSousCategory = null
        this.selectedType = null
        this.selectedRubrique = null
        this.selectedSousRubrique = null
        this.selectedGarantie = null
        this.selectedSegment = null
        this.selectedGamme = null
        this.selectedOaps = null
        this.selectedOags = null
        this.selectedGaranties = null
        this.attachment = ''
        this.secteur = ''
        this.url = ''
        this.ordre = 0
      },
      clearErrors() {
        this.errors.libelle = ''
        this.errors.code = ''
        this.errors.version = ''
        this.errors.date_debut = ''
        this.errors.date_fin = ''
        this.errors.description = ''
        this.errors.nom_fichier = ''
        this.errors.is_visible_client = false
        this.errors.date_publication_journal_officiel = ''
        this.errors.selectedCategory = ''
        this.errors.selectedSousCategory = ''
        this.errors.selectedType = ''
        this.errors.selectedRubrique = ''
        this.errors.selectedSousRubrique = ''
        this.errors.selectedSegment = ''
        this.errors.selectedGamme = ''
        this.errors.secteur = ''
        this.errors.url = ''
      },
      generateGammeOptions() {
        this.gammeOptions = [];

        if (this.secteur === 'ess') {
          this.gammeOptions.push({text: 'Général', value: null});
        }

        for (let gamme of this.allGammesProduit) {
          if (!isEmpty(this.secteur)) {
            let secteur = gamme.secteur.split(',');
            const filteredArray = secteur.filter(value => this.secteur === value);
            if (!isEmpty(filteredArray)) {
              this.gammeOptions.push({text: gamme.libelle, value: gamme.id});
            }
          } else {
            this.gammeOptions.push({text: gamme.libelle, value: gamme.id});
          }
        }
      },
    }
  }
  </script>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style scoped>

  </style>
